import { fields } from ".";
import Button from "components/atoms/Button";
import { modalActions } from "redux/slices/modal";
import { reduxForm } from "redux-form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import ReduxFormFields from "components/molecules/ReduxFormFields";

function RefundForm({ form, handleSubmit }: any) {
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking.booking);
  const payment_method = useAppSelector(
    (state) => state.form?.RefundForm?.values?.payment_method
  );
  const displayCurrency =
    booking?.price_details?.currency_short?.trim() || "SAR";

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <ReduxFormFields fields={fields(payment_method, displayCurrency)} />
        <br />

        <Button
          variant="outlined"
          sx={{ marginRight: "10px" }}
          onClick={() => dispatch(modalActions.closeModal())}
        >
          Cancel
        </Button>
        <Button type="submit" variant="contained">
          Submit
        </Button>
      </form>
    </div>
  );
}

export default reduxForm({ form: "RefundForm" })(RefundForm);
